module.exports = __webpack_public_path__ + "img/places-6.7f93987a.jpg";